import { Component, OnInit } from '@angular/core';
import {ContentfulService} from '../../services/contentful.service';
import {Video} from '../../models/video/video';
import {LiveEvent, LiveEventAdapter} from '../../models/live-event/live-event';
import * as moment from 'moment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  liveEvents: Video[];
  vodEvents = [];
  video;
  contentfulservice: ContentfulService;
  constructor(private contentfulService: ContentfulService) {
    this.contentfulservice = contentfulService;
  }

  ngOnInit() {
    const n = moment().subtract(12, 'hours').format();
    this.contentfulService.getLiveEvents({order: 'fields.startDate', 'fields.startDate[gte]': n, 'fields.vodStream[exists]': false}).then((res) => {
      const events = [];
      res.forEach((entry) => {
        const live = new LiveEventAdapter().creatLiveEventFromEntry(entry);
        if (live.featured || !this.video) {
          this.video = live;
        }
        events.push(live);
      });
      this.liveEvents = events;
    });
    this.contentfulService.getOnDemandEvents({order: 'fields.startDate', 'fields.vodStream[exists]': true}).then((res) => {
      this.vodEvents = [];
      res.forEach((entry) => {
        const live = new LiveEventAdapter().creatLiveEventFromEntry(entry);
        this.vodEvents.push(live);
        // if (!this.vodEvents[live.sport]) {
        //   this.vodEvents[live.sport] = [];
        // }
        // this.vodEvents[live.sport].push(live);
      });
    });
  }

}
